import { all } from 'redux-saga/effects'

import { mySaga } from './my/sagas'

export function* jobRecommendationsSaga() {
  yield all([mySaga()])
}
